﻿$.fn.dxCtrlDomaineDedieEmail = function custom_dxCtrlDomaineDedieEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrldomainededieemail dx-ctrl");
        this.createInstance(new cdxCtrlDomaineDedieEmail(this, option));
    }
    return this;
}

window.cdxCtrlDomaineDedieEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty();

        $("<div style='font-size:120%;text-align:center;'>Pour pouvoir envoyer des emails via <b>" + option.domaine + "</b>,<br/>vous devez disposez d'une adresse email sur ce domaine.</div>").appendTo(container)

        var lstEmailUti = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataEmail) {
            return dataEmail.adresse_email.endsWith("@" + option.domaine)
        })
        var lstEmail = option.bddCtrl.mGetArray("compte_email").filter(function (dataEmail) {
            return dataEmail.adresse_email.endsWith("@" + option.domaine)
        })
        if (lstEmailUti.length > 0) {
            $("<div style='text-align:center;margin-top:20px;'>Vous disposez " + ((lstEmailUti.length == 1) ? "d'une" : "de " + lstEmailUti.length) + " adresse" + ((lstEmailUti.length > 1) ? "s" : "") + " email" + ((lstEmailUti.length > 1) ? "s" : "") + " sur <b>" + option.domaine + "</b>.</div>").appendTo(container)
            lstEmailUti.forEach(function (dataEmail) {
                $("<div style='font-weight:bold;text-align:center;'/>").appendTo(container).html("<u>" + dataEmail.adresse_email + "</u>")
            })

            if (lstEmailUti.length == 1) {
                $("<div style='text-align:center;padding-top:30px;'>Pour vos envois d'emailing via votre domaine dédié <b>" + option.domaine + "</b>,<br/>vous devrez utiliser l'adresse <u>" + lstEmailUti[0].adresse_email + "</u> comme expéditeur.</div>").appendTo(container)
            } else {
                $("<div style='text-align:center;padding-top:30px;'>Pour vos envois d'emailing via votre domaine dédié <b>" + option.domaine + "</b>,<br/>vous devrez utiliser une de ces adresses en tant qu'expéditeur.</div>").appendTo(container)
            }
            //$("<div style='text-align:center;paddint-top:30px;'>Si vous voulez utiliser une autre adresse email sur <b>" + option.domaine + "</b> pour vos envois emailing,<br/>vous pouvez rajouter une autre adresse email à votre compte utilisateur.</div>").appendTo(container)
            //mAddSaisieEmail(lstEmail)
        } else {
            if (lstEmail.length > 0) {
                $("<div style='text-align:center;padding-top:30px;'>Vous n'avez aucune adresse email sur <b>" + option.domaine + "</b> sur votre compte utilisateur.</div>").appendTo(container)
                $("<div style='text-align:center;'>Par contre, un où des utilisateur(s) dispose d'une (ou de plusieurs) adresse(s) email(s) sur <b>" + option.domaine + "</b>.</div>").appendTo(container)

                var $ul = $("<ul style='margin:20px 20%;'/>").appendTo(container)
                lstEmail.forEach(function (dataEmail) {
                    var dataUti = option.bddCtrl.mGetArray("utilisateur").filter(function (o) { return o.id_utilisateur == dataEmail.id_utilisateur })[0]
                    $("<li/>").appendTo($ul).text(dataEmail.adresse_email + " &bull; " + option.bddCtrl.getObjet(dataUti).mGetLib1())
                })

                $("<div style='text-align:center;'>Contactez l'un de ces utilisateurs pour lui demander<br/>de partager son adresse email avec vous pour que vous puissiez l'utiliser pour vos emailings.</div>").appendTo(container)


                $("<div style='text-align:center;paddint-top:20px;'>Vous pouvez aussi choisir d'utiliser une adresse email<br/>auxquels vous avez accés sur <b>" + option.domaine + "</b>.</div>").appendTo(container)
                $("<div style='text-align:center;'>Veuillez saisir une adresse email valide de <b>" + option.domaine + "</b>.<br/>celle-ci sera rajoutée sur votre compte utilisateur<br/>et vous pourrez l'utiliser pour vos envois d'emailing.</div>").appendTo(container)
                mAddSaisieEmail(lstEmail)
            } else {
                $("<div style='text-align:center;padding-top:30px;'>Vous n'avez aucune adresse email sur <b>" + option.domaine + "</b> configurée dans votre espace " + parametre.nom + ".</div>").appendTo(container)
                $("<div style='text-align:center;padding-top:10px;'>Veuillez saisir une adresse email valide de <b>" + option.domaine + "</b>.<br/>celle-ci sera rajoutée sur votre compte utilisateur<br/>et vous pourrez l'utiliser pour vos envois d'emailing.</div>").appendTo(container)

                mAddSaisieEmail([])
            }
            $("<div style='text-align:center;padding-top:30px;font-style:italic;'>(Vous pouvez ignorer cette étape et rajouter votre adresse email plus tard)</div>").appendTo(container)
        }

    }

    this.isInSaisieCode = false
    function mAddSaisieEmail(lstDataEmail) {
        var $Table = $("<table style='margin:20px 20%;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var dxAdrEmail = $("<div/>").appendTo($Td).dxCtrlTextBox({
            label: "Nouvelle adresse email",
            labelMode: 'floating',
            value: option.adresse_email,
            onValueChanged: function (e) {
                if (dxAdrEmail.option("value") == "") {
                    option.onValueChanged("")
                    return
                }
                //if (!dxAdrEmail.option("value").endsWith("@" + option.domaine)) {
                //    mNotify("Veuillez saisir une adresse email sur votre domaine", "error", 6000)
                //    dxAdrEmail.option("value", "")
                //    e.component.focus()
                //    return
                //}
                if (lstDataEmail.filter(function (o) { return o.adresse_email == e.value + "@" + option.domaine }).length>0) {
                    mNotify("Cette adresse email existe déjà dans votre environnement", "error", 6000)
                    dxAdrEmail.option("value", "")
                    e.component.focus()
                    return
                }

                Me.isInSaisieCode = true
                $("<div/>").appendTo("body").dxCtrlSaisieCode({
                    bddCtrl: option.bddCtrl,
                    title: "Confirmez votre email",
                    adresse_email: e.value + "@" + option.domaine,
                    from: "Création domaine dédié (dxCtrlDomaineDedieEmail)",
                    onValide: function () {
                        option.onValueChanged(e.value + "@" + option.domaine)
                        Me.isInSaisieCode = false
                    },
                    onCancel: function () {
                        dxAdrEmail.option("value", "")
                        e.component.focus()
                        mNotify("La saisie de votre adresse email a été annulée.", "warning", 6000)
                        Me.isInSaisieCode = false
                    }
                })
            }
        }).dxCtrlTextBox("instance")
        var $Td = $("<td style='width:1px;font-size:120%;font-weight:bold;'>@" + option.domaine + "</td>").appendTo($Tr)
    }

    this.element = function () { return container }

    mConstruit();
}